import(/* webpackMode: "eager" */ "/home/node/app/src/app/contact/page.tsx");
